export enum QueryKeys {
    HEALTH = 'health',
}
